module.exports = __webpack_public_path__ + "img/p9.80afbc39.png";